import {last} from "lodash";

const EXPANSION_TABLE_COLUMN_PROPORTIONS: {[key: string]: number[]} = {
    root:[3,1,1],
    nested:[1,3,1]
}

export const getColumnProportion = (type: string, i: number) => EXPANSION_TABLE_COLUMN_PROPORTIONS[type][i] || last(EXPANSION_TABLE_COLUMN_PROPORTIONS[type])
